import { useInView } from "framer-motion";
import { useRef } from "react";
import Section from "../Section";
import LeftArrowSVG from "../SVG/LeftArrowSVG";
import RightArrowSVG from "../SVG/RightArrowSVG";

const Gallery = ({ imgList }) => {
  const { inView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  const scrollContainerRef = useRef(null);

  const handleScroll = (direction) => {
    const scrollAmount = 1000; // Amount to scroll
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      {imgList && imgList.length > 0 && (
        <Section bg={"bg-inherit"}>
          <div className="col-span-full px-8">
            <div className="col-span-11 h-[2px] bg-black opacity-30 " />
            <div className="col-span-11 relative">
              <button
                onClick={() => handleScroll("left")}
                className="hidden absolute left-12 top-1/2 transform -translate-y-1/2 bg-primary-light text-primary-orange border-2 hover:border-primary-orange p-6 rounded-full z-10  transition rotate-180 xl:flex items-center justify-center"
              >
                <LeftArrowSVG size={56} />
              </button>
              {/* <div
                ref={scrollContainerRef}
                className={`flex items-center justify-center gap-4 py-12 ${
                  inView ? "fade-in" : ""
                } overflow-x-auto xl:overflow-hidden snap-x snap-mandatory scroll-smooth scrollbar-hide scroll-padding-left`}
              >
                {imgList.map((url, index) => (
                  <div
                    key={index}
                    className={`${
                      index === 0 ? "ml-4" : ""
                    } transition-all transform duration-300 ease-in-out h-96 w-96 max-w-full bg-black rounded-lg flex-shrink-0 flex flex-col items-center gap-4 text-primary-dark snap-start sm:w-auto cursor-pointer`}
                  >
                    <img
                      src={url}
                      alt={`Gallery ${index + 1}`}
                      className={`h-full w-full object-cover duration-500 ease-in-out transform hover:opacity-80`}
                    />
                  </div>
                ))}
              </div> */}
              <div
                ref={scrollContainerRef}
                className={`flex items-center justify-start gap-4 py-12 pl-4
    ${
      inView ? "fade-in" : ""
    } overflow-x-auto xl:overflow-hidden snap-x snap-mandatory scroll-smooth scrollbar-hide`}
                style={{ scrollPaddingLeft: "1rem" }} // Ensure first image is fully visible
              >
                {imgList.map((url, index) => (
                  <div
                    key={index}
                    className="transition-all transform duration-300 ease-in-out h-96 w-96 max-w-full bg-black rounded-lg flex-shrink-0 flex flex-col items-center gap-4 text-primary-dark snap-start sm:w-auto cursor-pointer"
                  >
                    <img
                      src={url}
                      alt={`Gallery ${index + 1}`}
                      className="h-full w-full object-cover duration-500 ease-in-out transform hover:opacity-80"
                    />
                  </div>
                ))}
              </div>

              <button
                onClick={() => handleScroll("right")}
                className=" hidden absolute right-12 top-1/2 transform -translate-y-1/2 bg-primary-light text-primary-orange border-2 hover:border-primary-orange p-6 rounded-full z-10  transition xl:flex items-center justify-center"
              >
                <RightArrowSVG size={56} />
              </button>
            </div>
          </div>
        </Section>
      )}
    </>
  );
};

export default Gallery;
